<style scoped>
.size-row:hover {background-color:#fed202}
</style>

<template>
    
    <div>
        <div class="notification is-warning" v-if="loading == true || loading_user == true">
            Loading your data ...
        </div>
        
        <div v-if="loading == false && loading_user == false && (area == '' || area == null)" >
            
            <p>Where are you working today ?</p><br />
            <button class="button is-large is-fullwidth is-info" :disabled="loading==true" @click="updateArea('saving')" v-if="user.user_ireland==1">Saving Digital Print</button><br />
            <button class="button is-large is-fullwidth is-info" v-if="operationAllowed('paper')==true" :disabled="loading==true" @click="updateArea('paper')">Digital Printing Paper</button><br />
            <button class="button is-large is-fullwidth is-info" v-if="operationAllowed('rolls')==true" :disabled="loading==true" @click="updateArea('rolls')">Transmatic Rolls</button><br />
            <button class="button is-large is-fullwidth is-info" v-if="operationAllowed('cutting')==true" :disabled="loading==true" @click="updateArea('cutting')">Gerber Cutting</button><br />
            <button class="button is-large is-fullwidth is-link" :disabled="loading==true" @click="updateArea('multiply_cutting')" >Multi-Ply Gerber Cutting</button> <!-- removed restriction on ireland only users -->
        </div>

        <div v-if="loading == false && loading_user == false && (area != '' && order.orderID > 0)" >
            <div class="columns is-mobile" >
                
                <div class="column has-text-centered">
                    <h2 class="title">{{ selectedArea }} - {{ user.firstname }} {{ user.surname }}</h2>
                    <span class="">PO Number : <strong>{{ order.ponumber }}</strong></span><br />
                    
                    <select class="input is-small" v-model="machine_id" v-if="area=='rolls' || area == 'cutting' || area == 'paper' || area == 'multiply_cutting'">
                        <option value="">Select Machine</option>
                        <option v-bind:value="row.id" v-for="row in machines" :key="row.id">{{ row.name }}</option>
                        
                </select>
                </div>
                
            </div>

            <div v-if="area=='rolls' || area == 'cutting' || area == 'paper' || area == 'multiply_cutting'">
            
              <div class="columns is-mobile" >
                  <div class="column has-text-right">
                      
                  </div>
                  <div class="column has-text-centered">
                    <button class="button is-small is-success" @click="completeAll()" :disabled="working==true" v-if="(area == 'paper' && order.printing_papers.length == 0) || (area == 'rolls' && order.printing_rolls.length == 0) || (area == 'cutting' && order.cuttings.length == 0) || (area == 'multiply_cutting' && order.multiply_cuttings.length == 0)">Complete All</button>
                    <button v-else class="button is-small button-grey" onClick="alert('You can no longer Complete All as some sizes have already been completed')">Complete All</button>
                  </div>
                  <div class="column">
                      
                  </div>
              </div>

              <div class="" v-for="size in sizesWithQtys" :key="size.id" >
                  <SizeRow :size="size" :order="order" @submitForm="submitSizeRow($event, size.id)" :working="working" :area="area"/>
              </div>
            </div>
            <div v-else-if="area=='saving'" class="column has-text-centered mb-5">

              <div v-if="order.printing_saves.length > 0">
                <p>This order has  been marked as saved or repeat</p>
                <table class="table is-fullwidth">
                  <thead>
                      <tr>
                          <th>Date/Time</th>
                          <th>User</th>
                          <th>Status</th>
                          
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="row in order.printing_saves" :key="row.id">
                          <td>{{ row.date }}</td>
                          <td>{{ row.user_forename }} {{row.user_surname }} </td>
                          <td>{{ showSaveStatus(row.status) }}</td>
                          
                      </tr>
                      
                      </tbody>
              </table>
              </div>
              <div v-if="order.printing_saves.length == 0">
                <p class="mb-4">The system has <strong>not</strong> detected that this order has been <strong>saved</strong>. This is required before printing.</p>
                <p class="mb-3"><button class="button is-success" @click="submitSave(1)" :disabled="working == true">I have now Saved this order</button></p>
                <p class="mb-3"><button class="button is-info" @click="submitSave(2)" :disabled="working == true">This is a repeat order. Saving has already been done</button></p>
                <p class="mb-3"><button class="button is-warning" @click="submitSave(3)" :disabled="working == true">Saving was done before the new system was in place</button></p>
                
            </div>
              
            </div>
            
            
            

            <div class="columns is-mobile" >
                <div class="column has-text-right">
                    
                </div>
                <div class="column has-text-centered">
                    <button class="button is-small is-danger" @click="clearScreen()" :disabled="working==true">Back To Search Screen</button>
                </div>
                <div class="column">
                    
                </div>
            </div>

            <div v-if="area == 'paper' && order.printing_papers.length > 0">
              <h4 class="title is-5">Order Log</h4>
              <table class="table is-fullwidth">
                  <thead>
                      <tr>
                          <th>Date/Time</th>
                          <th>User</th>
                          <th>Machine</th>
                          <th>Size</th>
                          <th>Qty</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="row in order.printing_papers" :key="row.id">
                          <td>{{ row.date }}</td>
                          <td>{{ row.user_forename }} {{row.user_surname }} </td>
                          <td>{{ row.machine_name }}</td>
                          <td>{{ row.size_name }}</td>
                          <td>{{ row.qty }}</td>
                      </tr>
                      
                      </tbody>
              </table>
            </div>
            <div v-if="area == 'rolls' && order.printing_rolls.length > 0">
              <h4 class="title is-5">Order Log</h4>
              <table class="table is-fullwidth">
                  <thead>
                      <tr>
                          <th>Date/Time</th>
                          <th>User</th>
                          <th>Machine</th>
                          <th>Size</th>
                          <th>Qty</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="row in order.printing_rolls" :key="row.id">
                          <td>{{ row.date }}</td>
                          <td>{{ row.user_forename }} {{row.user_surname }} </td>
                          <td>{{ row.machine_name }}</td>
                          <td>{{ row.size_name }}</td>
                          <td>{{ row.qty }}</td>
                      </tr>
                      
                      </tbody>
              </table>
            </div>
             <div v-if="area == 'cutting' && order.cuttings.length > 0">
              <h4 class="title is-5">Order Log</h4>
              <table class="table is-fullwidth">
                  <thead>
                      <tr>
                          <th>Date/Time</th>
                          <th>User</th>
                          <th>Machine</th>
                          <th>Size</th>
                          <th>Qty</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="row in order.cuttings" :key="row.id">
                          <td>{{ row.date }}</td>
                          <td>{{ row.user_forename }} {{row.user_surname }} </td>
                          <td>{{ row.machine_name }}</td>
                          <td>{{ row.size_name }}</td>
                          <td>{{ row.qty }}</td>
                      </tr>
                      
                      </tbody>
              </table>
            </div>

            <div v-if="area == 'multiply_cutting' && order.multiply_cuttings.length > 0">
              <h4 class="title is-5">Order Log</h4>
              <table class="table is-fullwidth">
                  <thead>
                      <tr>
                          <th>Date/Time</th>
                          <th>User</th>
                          <th>Machine</th>
                          <th>Size</th>
                          <th>Qty</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="row in order.multiply_cuttings" :key="row.id">
                          <td>{{ row.date }}</td>
                          <td>{{ row.user_forename }} {{row.user_surname }} </td>
                          <td>{{ row.machine_name }}</td>
                          <td>{{ row.size_name }}</td>
                          <td>{{ row.qty }}</td>
                      </tr>
                      
                      </tbody>
              </table>
            </div>
            
        </div>
        <div v-if="loading == false && loading_user == false && (area != '' && (order.orderID == 0 || order.orderID == null))" >
            <h3 class="title is-size-5">{{ selectedArea }}  - {{ user.firstname }} {{ user.surname }} </h3>
            <form @submit.prevent="getOrder()" >
            <input class="input is-large" type="text" placeholder="Enter order number here" v-model="ponumber" ref="printing_data_input" autocomplete="off"><br /><br />
            <button class="button is-large is-fullwidth is-info" :disabled="loading==true" >Search</button>
            </form>

            <br /><br />
            <button class="button is-large is-fullwidth is-warning" :disabled="loading==true" @click="updateArea('')">Change Area</button>
        </div>
        
    </div>
</template>

<script>
import SizeRow from '@/components/PrintingCutting/SizeRow.vue';
import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
 name: 'DigitalPrintInput',
 components: {SizeRow},
  mixins: [OrderMixin],
  data() {
    
    return {
      order: {orderID: 0},
      area: '',
      loading: false,
      loading_user: true,
      working:false,
      ponumber: '',
      access_token: '',
      sizes: [],
      machines: [],
      machine_id: '',
      user: [],
      
    }
  },
   methods: {
     clearScreen() {
      this.order=[]
      this.ponumber = ''
      this.focusInput();
     },
      async getOrder(noLoading) {

        if(noLoading == true)
        {
          // Don't show the loading screen
        }
        else{
          this.loading=true
        }
        
        OrderService.getOrderByPONumber(this.accessToken, this.ponumber, this.area)
        .then(
          (order => {
            if(order[0] != null)
            {
                this.$set(this, "order", order[0]);
            }
            else if(order.length == 0)
            {
              alert("Order could not be found")
            }
            else{
                console.log(order)
            }
            
            this.loading=false
            this.working = false
          }).bind(this)
        );
      },
      operationAllowed(operation_name) {
        return this.user.operations.some(operation => operation.name === operation_name);
      },
      
       updateArea(value) {
        this.loading=true
        this.area = value
        this.loading = false;
        this.machine_id = '';
        this.focusInput();
      },
      focusInput() {
          this.$nextTick(() => this.$refs.printing_data_input.focus())
      },
      async submitSizeRow(qty, size_id)
      {
          this.working = true

          if(this.machine_id == "" || this.machine_id ==0 || this.machine_id == null)
          {
            alert("Please select the machine you are working on.")
            this.working = false
          }
          else{

            var order_id = this.order.orderID

            var formdata = { 
                qty: qty,
                size_id: size_id,
                order_id: order_id,
                machine_id: this.machine_id
            }; 

            OrderService.printingCuttingInputData(this.accessToken, formdata, this.area)
            .then(() => {
                this.getOrder(true)
                //console.log(response)
            }).catch((error) => {
              
              alert("ERROR: " + error.response.data.message)
                console.log("Error:" + JSON.stringify(error.response.data));
                this.working = false
            });
           }
      },
      async submitSave(status)
      {
          this.working = true

         var order_id = this.order.orderID

          var formdata = { 
              order_id: order_id,
              status: status
          }; 

            OrderService.updateOrderPrintingSave(this.accessToken, formdata)
            .then(() => {
                this.getOrder(true)
                //console.log(response)
            }).catch((error) => {
              alert("Something went wrong and the data has not been saved. Please reload and try again")
                console.log("Error:" + JSON.stringify(error.response.data));
                this.working = false
            });
           
      },
      async completeAll()
      {
          this.working = true

          if(this.machine_id == "" || this.machine_id ==0 || this.machine_id == null)
          {
            alert("Please select the machine you are working on.")
            this.working = false
          }
          else{

            var order_id = this.order.orderID

            var formdata = { 
                order_id: order_id,
                machine_id: this.machine_id
            }; 

            OrderService.printingCuttingInputDataCompleteAll(this.accessToken, formdata, this.area)
            .then(() => {
                this.getOrder(true)
                //console.log(response)
            }).catch((error) => {
              alert("ERROR: " + error.response.data.message)
                console.log("Error:" + JSON.stringify(error.response.data));
                this.working = false
            });
           }
      },

      
      async getMachines() {
        UtilityService.getSimpleApiData(this.accessToken, "machines?printing_paper=" + this.printing_paper + "&printing_rolls=" + this.printing_rolls + "&cutting=" + this.cutting).then(
               response => this.machines = response 
            );
      },
      checkForQueryString()
      {
        if(this.$route.query.ponumber != "" && this.$route.query.ponumber != undefined)
        {
          this.ponumber = this.$route.query.ponumber
          console.log(this.$route.query.ponumber)
        }
        
        if(this.$route.query.area != "" && this.$route.query.area != undefined)
        {
          this.updateArea(this.$route.query.area)
          console.log(this.$route.query.area)
        }

        if(this.area != "")
        {
          this.focusInput();
        }
      },

      
   },
   mounted() {
    if (localStorage.area) {
      this.area = localStorage.area;
    }
    else{
      this.area = ''
    }

    if (localStorage.machine_id) {
      this.machine_id = localStorage.machine_id;
    }
    else{
      this.machine_id = ''
    }

    this.checkForQueryString();
    
    
  },
  computed : {
      sizesWithQtys: function () {  
          let order = this.order
        let sizesWithQtys =  this.sizes.filter(function(u) {
            if( order[u.database_name] > 0 ||  order[u.database_name + '_GK'] > 0) 
            {
               console.log(u)
              return 1
            }
          })

          return sizesWithQtys 
     },
     printing_paper: function () {
       if(this.area == 'paper')
       {
         return 1
       }
       else{
         return 0
       }
     },
     printing_rolls: function () {
       if(this.area == 'rolls')
       {
         return 1
       }
       else{
         return 0
       }
     },
     cutting: function () {
       if(this.area == 'cutting' || this.area == 'multiply_cutting')
       {
         return 1
       }
       else{
         return 0
       }
     }
  },
  watch: {

    area: function () {
     localStorage.area = this.area;
      this.getMachines()
    },
    machine_id: function () {
     localStorage.machine_id = this.machine_id;
      //this.getArtworksFinished()
    },
    loading_user: function () {
     if(this.loading_user == false)
     {
      this.focusInput();
      console.log("Tried to set focus here")
     }
    },
  },
  created() {

    

     this.getAccessToken()
        .then(() => { 
          this.getUserProfile(0, 1); // Second parameter is operations
           this.getSizes();
           this.getMachines();

           //console.log("Tried to set focus here")
        });

        
  },
}
</script>